import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from '~/../../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);
const breakpoints = fullConfig.theme.screens;

Object.keys(breakpoints).forEach((breakpointName: string) => {
  const breakpointWidthWithPx: string = breakpoints[breakpointName];

  breakpoints[breakpointName] = Number(breakpointWidthWithPx.replace('px', ''));
});

export enum BreakpointWidthEnum {
  XS2 = '0', // Not specify in Tailwind config cause it's the default value.
  XS = '600px',
  SM = '601px',
  MD = '900px',
  LG = '1302px',
  XL = '1688px',
  XL2 = '1884px',
}
